import React from 'react';
import { FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

const LegalNotice = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#ECEC75] via-[#e6e67c] to-[#ECEC75] py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-black rounded-full mb-6">
            <FileText size={40} className="text-[#D4AF37]" />
          </div>
          <h1 className="text-5xl font-bold text-black mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>
            Mentions Légales
          </h1>
          <p className="text-xl text-black/70">
            Informations légales du site
          </p>
        </div>

        {/* Content */}
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-8 md:p-12 space-y-8">
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">1. Éditeur du site</h2>
              <div className="p-6 bg-[#D4AF37]/10 rounded-xl">
                <p className="text-black/80 mb-2"><strong>Raison sociale :</strong> Le Cosmos Tacos</p>
                <p className="text-black/80 mb-2"><strong>Forme juridique :</strong> Entreprise individuelle</p>
                <p className="text-black/80 mb-2"><strong>SIRET :</strong> 931 222 780 00013</p>
                <p className="text-black/80 mb-2"><strong>Adresse :</strong> 49 Av. de la Libération, 42000 Saint-Étienne</p>
                <p className="text-black/80 mb-2"><strong>Téléphone :</strong> 04 87 66 22 41</p>
                <p className="text-black/80"><strong>Responsable de publication :</strong> La Direction</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">2. Hébergement</h2>
              <div className="p-6 bg-black/5 rounded-xl">
                <p className="text-black/80 mb-2"><strong>Hébergeur :</strong> Emergent Agent</p>
                <p className="text-black/80 mb-2"><strong>Site web :</strong> <a href="https://emergent.sh" className="text-[#D4AF37] hover:underline">emergent.sh</a></p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">3. Propriété intellectuelle</h2>
              <p className="text-black/80 leading-relaxed mb-4">
                L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur 
                et la propriété intellectuelle. Tous les droits de reproduction sont réservés.
              </p>
              <ul className="list-disc list-inside space-y-2 text-black/80 ml-4">
                <li>Le logo "Le Cosmos Tacos" est une marque protégée</li>
                <li>Les textes, images et graphismes sont protégés par le droit d'auteur</li>
                <li>Toute reproduction sans autorisation est interdite</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">4. Protection des données</h2>
              <p className="text-black/80 leading-relaxed mb-4">
                Conformément à la loi "Informatique et Libertés" et au Règlement Général sur la Protection des Données (RGPD),
                vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles.
              </p>
              <p className="text-black/80">
                Consultez notre <Link to="/privacy" className="text-[#D4AF37] hover:underline">politique de confidentialité</Link> pour plus d'informations.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">5. Cookies</h2>
              <p className="text-black/80 leading-relaxed">
                Ce site utilise des cookies pour améliorer votre expérience. Pour en savoir plus, consultez notre 
                <Link to="/cookies" className="text-[#D4AF37] hover:underline ml-1">politique des cookies</Link>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">6. Responsabilité</h2>
              <p className="text-black/80 leading-relaxed mb-4">
                Le Cosmos Tacos s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site.
                Toutefois, nous ne pouvons garantir l'exactitude, la précision ou l'exhaustivité des informations.
              </p>
              <p className="text-black/80 leading-relaxed">
                En conséquence, nous déclinons toute responsabilité pour toute imprécision, inexactitude ou omission
                portant sur des informations disponibles sur ce site.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">7. Liens hypertextes</h2>
              <p className="text-black/80 leading-relaxed">
                Le site peut contenir des liens vers d'autres sites (Uber Eats, Deliveroo, Google Maps).
                Le Cosmos Tacos n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">8. Droit applicable</h2>
              <p className="text-black/80 leading-relaxed">
                Les présentes mentions légales sont régies par le droit français. En cas de litige,
                les tribunaux français seront seuls compétents.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">9. Contact</h2>
              <p className="text-black/80 leading-relaxed mb-4">
                Pour toute question concernant ces mentions légales :
              </p>
              <div className="p-6 bg-black text-white rounded-xl">
                <p className="font-bold mb-2">Le Cosmos Tacos</p>
                <p>49 Av. de la Libération, 42000 Saint-Étienne</p>
                <p>Tél : 04 87 66 22 41</p>
              </div>
            </section>
          </div>
        </div>

        {/* Back Button */}
        <div className="text-center mt-8">
          <Link
            to="/"
            className="inline-block bg-black text-white px-8 py-3 rounded-lg font-semibold hover:bg-black/90 transition-colors"
          >
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LegalNotice;
